import React, { useState, useEffect } from "react";
import { Breadcrumb } from "@gull";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";

import queryString from "app/services/queryStringService";
import _ from "lodash";
import { MdEdit, MdVpnKey, MdSearch, MdRefresh } from "react-icons/md";
import Swal from "sweetalert2";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { Button, Form } from "react-bootstrap";
import Tooltip from "rc-tooltip";
// import MarkupModal from "./MarkupModal";

import { getMarkUp, addMarkUp } from "app/services/markUpService";
import { NotificationManager } from "react-notifications";
import usePagePermission from "app/hooks/usePagePermission";
import { getAirportsList } from "app/services/SearchService";
import AddAirports from "./Components/Airport/AddAirports";
import { FaPaperPlane, FaPlane } from "react-icons/fa";
import HandyScroll from "app/common/Scroll";

const AirportsList = () => {
  const { canAdd, canView, canEdit, canDelete } = usePagePermission();

  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(false);
  const [editId, setEditId] = useState(0);
  const [editRow, setEditRow] = useState(null);
  const [SearchText, setSearchText] = useState("");
  const [isRefreshed, setIsRefreshed] = useState(false);

  const handleSearchChanges = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "SearchText":
        setSearchText(value);
        break;
    }
  };

  const refreshFilter = (e) => {
    setSearchText("");

    setIsRefreshed(true);
  };
  useEffect(() => {
    if (isRefreshed) {
      loadAirport();
    }
  }, [isRefreshed]);

  const airportTypeFormatter = (cell, row) => {
    if (row.airportType === "domestic") {
      return <span>Domestic </span>;
    } else {
      return <span>International</span>;
    }
  };

  const editHandler = (row) => {
    setEditId(row.id);
    setEditRow(row);
    handleShow();
  };

  const actionFormatter = (cell, row) => {
    return (
      <>
        {/* <DropdownButton variant="outline-primary" title="Action" size="sm">
          <Dropdown.Item onClick={() => editHandler(row)}> */}
        <MdEdit
          cursor={"pointer"}
          className="text-primary mr-4"
          size={15}
          onClick={() => editHandler(row)}
        ></MdEdit>
        {/* Edit
          </Dropdown.Item>
        </DropdownButton> */}
      </>
    );
  };

  const columns = [
    {
      dataField: "cityCode",
      text: "Airport Code",
      headerStyle: (colum, colIndex) => {
        return { width: "80px", textAlign: "center" };
      },
    },
    {
      dataField: "airportName",
      text: "Airport Name",
      headerStyle: (colum, colIndex) => {
        return { width: "250px", textAlign: "center" };
      },
    },
    {
      dataField: "cityName",
      text: "City Name",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "countryCode",
      text: "Country Code",
      headerStyle: (colum, colIndex) => {
        return { width: "80px", textAlign: "center" };
      },
    },
    {
      dataField: "airportType",
      text: "Airport Type",
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center", width: "100px" };
      },
      formatter: airportTypeFormatter,
    },
    {
      dataField: "id",
      text: "Action",
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center", width: "80px" };
      },
      formatter: actionFormatter,
    },
  ];

  const rowStyle = (row, rowIndex) => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    return style;
  };

  const NoDataIndication = () => {
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  };
  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="mr-2">Page Size</label>
      <div className="btn-group mr-4" role="group">
        {options.map((option, i) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary" : "btn-secondary"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };
  const loadAirport = async () => {
    const query = queryString.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
      SearchText: SearchText,
    });
    if (dataCount !== 0) {
      setLoading(true);
    }
    const response = await getAirportsList(query);

    const data = response.data.data;
    const paggingData = JSON.parse(response.headers["x-pagination"]);
    setData(data);
    setDataCount(paggingData.TotalCount);
    setPage(paggingData.CurrentPage);
    setSizePerPage(paggingData.PageSize);
    setLoading(false);
  };

  useEffect(() => {
    loadAirport();
  }, [page, sizePerPage, SearchText]);

  const handleTableChange = async (type, { page, sizePerPage }) => {
    setPage(page);
    setSizePerPage(sizePerPage);
    setTimeout(async () => {
      await loadAirport();
    }, 10);
  };

  const handleSearch = async () => {
    setPage(1);
    setSizePerPage(10);
    // setIsRefreshed(false);
    setTimeout(async () => {
      await loadAirport();
    }, 10);
  };

  const handleClose = () => {
    setShow(false);
    setTimeout(async () => {
      await loadAirport();
    }, 10);
  };

  const handleShow = () => {
    setShow(true);
  };

  return (
    <div>
      {canAdd && (
        <Link
          className="btn btn-primary btn-md float-end"
          to="#"
          variant="primary"
          onClick={() => {
            setEditRow(null);
            handleShow();
          }}
        >
          <FaPaperPlane style={{ marginRight: 10 }}></FaPaperPlane>Add Airport
        </Link>
      )}
      <AddAirports
        loadAirport={loadAirport}
        show={show}
        handleClose={handleClose}
        handleShow={handleShow}
        editRow={editRow}
      />
      <Helmet>
        <title>Airports List</title>
      </Helmet>
      <Breadcrumb routeSegments={[{ name: "Airports List" }]}></Breadcrumb>

      <div className="card card-body rounded border my-1">
        <div className="row">
          <div className="col-md-9 col-12 mb-1">
            <div className="form-group">
              <label>Search</label>
            </div>
            <div className="input-group mb-3">
              <input
                type="text"
                className="form-control"
                id="SearchText"
                placeholder="Search"
                value={SearchText}
                name="SearchText"
                onChange={handleSearchChanges}
              />
            </div>
          </div>

          <div
            className="col-12  col-md-3  d-flex justify-content-around mb-3 float-end"
            style={{ marginTop: "3%" }}
          >
            <button
              className="btn btn-outline-primary mr-3 justify-content-around"
              onClick={handleSearch}
            >
              <MdSearch className="mx-2" size={18} />
            </button>
            <button
              className="btn btn-outline-primary"
              onClick={() => refreshFilter()}
            >
              <MdRefresh className="mx-2" size={18} />
            </button>
          </div>
        </div>
      </div>

      <HandyScroll>
        <div
          class="spacious-container"
          data-handy-scroll
          style={{ overflow: "auto" }}
        >
          <BootstrapTable
            hover
            remote
            keyField="id"
            data={data}
            columns={
              canEdit ? columns : columns.filter((x) => x.text !== "Action")
            }
            pagination={paginationFactory(paginationOptions)}
            onTableChange={handleTableChange}
            noDataIndication={() => <NoDataIndication />}
            headerClasses="bg-primary text-white"
            bodyClasses="react-bootstrap-table-next-min-height"
            rowStyle={rowStyle}
          />
        </div>
      </HandyScroll>
    </div>
  );
};

export default AirportsList;
